import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useCopyToClipboard from 'hooks/use-copy-to-clipboard'
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/pro-regular-svg-icons'
import Tooltip from '../tooltip'
import { useState } from 'react'

const BLOG_BASE_URL = 'https://www.trainwithkickoff.com/blog'

export default function Share({ id, title, slug, className }) {
  const [, copy] = useCopyToClipboard()
  const [copied, setCopied] = useState('')
  const url = `${BLOG_BASE_URL}/${slug}`
  const encodedUrl = encodeURIComponent(url)
  const encodedTitle = encodeURI(title)

  const handleCopyClick = () => {
    copy(url)
    setCopied('Copied')
    setTimeout(() => {
      setCopied('')
    }, 3000)
  }

  return (
    <div className={className}>
      <span>Share: </span>
      <a
        aria-label="Share on Facebook"
        id={`fb-share-${id}`}
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&t=${encodedTitle}`}>
        <FontAwesomeIcon icon={faFacebook as any} color="#850052" />
      </a>
      <a
        aria-label="Share on Twitter"
        id={`twitter-share-${id}`}
        href={`https://twitter.com/share?url=${encodedUrl}&text=${encodedTitle}`}>
        <FontAwesomeIcon icon={faTwitter as any} color="#850052" />
      </a>
      <Tooltip text={copied} show={copied}>
        <button
          onClick={handleCopyClick}
          aria-label="Copy and Share"
          id={`copy-share-${id}`}>
          <FontAwesomeIcon icon={faLink as any} color="#850052" />
        </button>
      </Tooltip>
    </div>
  )
}
